import { LogRepository } from "@domain/repositories/LogRepository";
import UseCase from "@domain/UseCase";
import { Log } from "@domain/models/Log";
import { Map } from "@domain/models/Map";

type Input = Map["id"];

type Output = Promise<Log[]>;

export class GetMapLogsUseCase implements UseCase<Input, Output> {
  constructor(private readonly logRepository: LogRepository) {}

  async execute(mapId: Input) {
    return this.logRepository.getMapLogs(mapId);
  }
}
